<template>
  <div class="bf-layout">
    <div class="bf-layout__header">
      <div
        v-if="$slots.mainMenu?.()"
        class="bf-layout__main-menu"
      >
        <slot name="mainMenu"></slot>
      </div>
      <slot name="header"></slot>
      <div class="bf-layout__buttons"></div>
    </div>

    <div class="bf-layout__content">
      <slot></slot>
    </div>

    <div class="hardware-modules">
      <div class="hardware-modules__header">
        <div class="bf-layout__logo"></div>

        <template v-if="hasBike && $slots.hardwareHeader?.()">
          <slot name="hardwareHeader"></slot>
        </template>

        <div
          class="bf-layout__toggle"
          @click="hardwareActive = !hardwareActive"
        >
          <BfIcon
            v-if="hasBike && $slots.hardwareModules?.()"
            :icon="
              hardwareActive
                ? '/icons/52-Arrows-Diagrams/01-Arrows/arrow-down-1.svg'
                : '/icons/52-Arrows-Diagrams/01-Arrows/arrow-up-1.svg'
            "
            :color="Colors.Light"
          />
        </div>
      </div>
      <div
        :class="[
          'hardware-modules__content',
          { 'hardware-modules__content--active': hardwareActive },
        ]"
      >
        <slot name="hardwareModules"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { BfIcon, Colors } from '@finetic/bikefitting-ui'
import { useProgressStore } from '@/store/progressStore'

withDefaults(
  defineProps<{
    hasBike?: boolean
  }>(),
  {
    hasBike: false,
  },
)

const progressStore = useProgressStore()

const { hardwareActive } = storeToRefs(progressStore)
</script>

<style lang="scss">
.bf-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    background-color: var(--color-light);
    gap: 1.6rem;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid var(--color-dark-10);
    z-index: 100;
  }

  &__buttons {
    margin-right: 2.4rem;
  }

  &__content {
    flex-grow: 1;
    padding-top: 6rem;
    overflow-y: auto;
    scrollbar-gutter: stable;
  }

  &__logo {
    background-image: url(@/assets/logo-white.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 19.2rem;
    height: 2.8rem;
  }

  &__toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-dark-90);
    width: 3.2rem;
    height: 3.2rem;
    border-radius: 3.2rem;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
      background-color: var(--color-dark-80);
    }
  }

  .hardware-modules {
    color: var(--color-light);
    background-color: var(--color-dark);

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.8rem 1.6rem;
      font-family: 'Roboto Condensed', sans-serif;
    }

    &__content {
      height: 0;

      &--active {
        height: auto;
      }
    }
  }
}
</style>
